export default __webpack_public_path__ + "static/media/demo-1.d701e8ea.png";